import { Component, OnDestroy, OnInit } from '@angular/core';
import { LayoutService } from '../../services/layout.service';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';

@Component({
  selector: 'pioneer-payment-layout',
  templateUrl: './payment-layout.component.html',
})
export class PaymentLayoutComponent implements OnInit, OnDestroy {

  showLayout = false;
  public imagesUrl= '';
  year: number = new Date().getFullYear();

  constructor(
    private environment: EnvironmentConfiguration,
    private layoutService: LayoutService,
  ) { }

  ngOnInit() {
    this.imagesUrl = this.environment.onyxGPImagesCommonDataUrl;
    setTimeout(() => {
      this.layoutService.showLayout.next(this.showLayout);
    });
  }

  ngOnDestroy(): void {
    this.layoutService.resetShowLayout();
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/payment/payment-layout/payment-layout.component.ts